import axios from 'axios';

const fetchExistedLanguages = async () => {
    try {
        const response = await axios.get('/api/shop/v1/lang/enabled.json')
        return response.data
    } catch (err) {
        throw (err)
    }
};

const getLanguageTranslation = async (languageKey) => {
    try {
        const response = await axios.get(`/api/shop/v1/lang/dictionary/${languageKey}.json`)
        return response.data
    } catch (err) {
        throw (err)
    }
};


export {
    fetchExistedLanguages,
    getLanguageTranslation
}